import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import NumericInput from 'react-numeric-input';
import clsx from 'clsx';

const styles = theme => ({
    NumericInput : {
        display: 'inline-block',
        '& b' : {
            background: '#FFF!important',
            border: '0!important',
            boxShadow: 'none!important',
            right: '8px!important',
            width: '10px!important',
            top: '10px!important',
            cursor: 'pointer!important'
        }, 
        '& b:last-child' : {
            top: 'inherit!important',
            bottom: '17px!important',
        },       
    },
    CSSInputNumber : {
        paddingLeft: '16px!important',
        borderRadius: '4px!important'
    },
    label : {
        color: '#989898',
        fontSize: '12px'
    },
});

class InputNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    render() {
        const { classes, onChange, target, label, isDisabled, classNameContainer,classLabel, classNameInput, error = false,  ...other } = this.props;
        let disabled = isDisabled === true ? true : false;
        return (
            <div className={ clsx(classes.NumericInput, classNameContainer)}>
                {label ? <div className={clsx(classes.label, classLabel)}>{label}</div> : ''}
                <NumericInput
                    {...other}
                    disabled={disabled}
                    className={clsx(classes.CSSInputNumber, classes.InputNumber, classNameInput)}
                    onChange={valueAsNumber =>
                        this.props.handleChangeInput(
                            valueAsNumber,
                        )
                    }
                    style={{
                        input: {
                            color: '#989898',
                            height: '41px',
                            lineHeight: '41px',
                            minWidth: 50,
                            border: '1px solid #E6EDF5',
                            borderColor: error ? 'red' : '#E6EDF5'
                        },
                        arrowUp: {
                            background: '#FFF',
                            borderBottomColor: '#6EA0D7'
                        },
                        arrowDown: {
                            background: 'transparent',
                            borderTopColor: '#6EA0D7'
                        }
                    }}
                />
            </div>
        )
    }
}
export default withStyles(styles)(InputNumber);